<template>
  <div id="moRoot">
    <slot name="moOption"></slot>
    <slot v-if="$store.state.openRebateUI1" name="moRebateUI1FirstSimbol"></slot>
    <slot v-else name="moFirstSimbol"></slot>
    <!-- <div id="moOption">hahah</div>
    <div id="moFirstSimbol">
      <label id="molabel">首次兑换</label>
    </div> -->
  </div>
</template>

<script>
 export default {
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style>
#moRoot{
  margin-left: 5px;
  margin-right: 5px;
  position: relative;
  width: 90px;
  height: 55px;
  display: flex;
  /* background-color: aqua; */
  justify-content: center; /*水平居中*/
  align-items: Center; /*垂直居中*/
  /* background-color: yellow; */
}
#moFirstSimbol{
  position: absolute;
  right: 0px;
  top:-0px;
  float: right;
  width: 50px;
  height: 15px;
  line-height: 10px;
  /* text-align: center; */
  /* vertical-align: center; */
  background: red;
  /* border: 1px solid red; */
  border-radius: 5px 5px 5px 5px;
  z-index: 201;
}

/* rebateUI1专用 */
#moRebateUI1FirstSimbol{
  position: absolute;
  right: 0px;
  top:-0px;
  float: right;
  width: 50px;
  height: 15px;
  line-height: 10px;
  /* text-align: center; */
  /* vertical-align: center; */
  background: #FF5273;
  /* border: 1px solid red; */
  border-radius: 5px 5px 5px 5px;
  z-index: 201;
}

#molabel{
  clear: inherit;
  float: right;
  display: flex;
  color: white;
  width: 100%;
  height: 100%;
  transform: scale(0.6);
  font-size: 10px;
  /* background-color: violet; */
}


  
.moOption{
  flex: 1;
  background: white;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  vertical-align: center;
  border: 1px solid gray;
  border-radius: 5px 5px 5px 5px;
  font-size: smaller;
  z-index: 200;
}
.selectedBg{
  flex: 1;
  background: white;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  vertical-align: center;
  border-radius: 5px 5px 5px 5px;
  font-size: smaller;
  z-index: 200;
  color: white;
  background: linear-gradient(to right,#FF9063, #FF3948);
}

/* rebateUI1专用 */
.rebateUI1SelectedBg{
  flex: 1;
  background: white;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  vertical-align: center;
  border-radius: 5px 5px 5px 5px;
  font-size: smaller;
  z-index: 200;
  color: white;
  background: linear-gradient(to right,#FF849C, #FF5273);
}
</style>


// WEBPACK FOOTER //
// src/views/RebateView/CashOut/MoneyOptionItem.vue